<template>
  <v-dialog-old ref="relationDialog" id="cityDialog">
    <div class="dialog-container" :class="{loading: loading}">
      <fieldset>
        <legend>Общее инфо</legend>
        <table class="grid">
          <tbody><tr>
            <td>
              <input class="large" v-model="city.name">
            </td>
            <td><input type="checkbox" value="1" class="large" v-model="city.published" title="Опубликован"></td>
          </tr>
          <tr>
            <td colspan="2">
              <label>CharId</label>
              <input :readonly="true" v-model="city.nameSlug">
            </td>
          </tr>
          </tbody></table>
      </fieldset>
      <fieldset v-if="city.nameInfo">
        <legend>Падежи</legend>
        <table class="grid">
          <tr>
            <th align="right">Именительный</th>
            <td><input placeholder="кто? что?" v-model="city.nameInfo.nominative"></td>
          </tr>
          <tr>
            <th align="right">Родительный</th>
            <td><input placeholder="кого? чего?" v-model="city.nameInfo.genitive"></td>
          </tr>
          <tr>
            <th align="right">Дательный</th>
            <td><input placeholder="кому? чему?" v-model="city.nameInfo.dative"></td>
          </tr>
          <tr>
            <th align="right">Винительный</th>
            <td><input placeholder="кого? что?" v-model="city.nameInfo.accusative"></td>
          </tr>
          <tr>
            <th align="right">Творительный</th>
            <td><input placeholder="кем? чем?" v-model="city.nameInfo.ablative"></td>
          </tr>
          <tr>
            <th align="right">Предложный</th>
            <td><input placeholder="о ком? о чем?" v-model="city.nameInfo.prepositional"></td>
          </tr>
          <tr>
            <th colspan="3">
              <hr>
            </th>
          </tr>
          <tr>
            <th align="right">Кратко</th>
            <td><input v-model="city.nameInfo.short"></td>
            <td></td>
          </tr>

          </table>
      </fieldset>
      <fieldset>
        <legend>Системная информация</legend>
        <table class="grid">
          <tr>
            <th>Телефон</th>
            <td rowspan="4">карта</td>
          </tr>
          <tr>
            <td><input v-model="city.phone"></td>
          </tr>
          <tr>
            <th>Приоритет</th>
          </tr>
          <tr>
            <td><input v-model="city.priority"></td>
          </tr>
        </table>
      </fieldset>
    </div>
    <template v-slot:footer>
      <div class="buttons">
        <div class="left">
          <button class="green" @click="accept" type="submit">Сохранить</button>
        </div>
        <div class="right">
          <button class="redHover" @click="hide">Отмена</button>
        </div>
      </div>
    </template>
  </v-dialog-old>
</template>

<script>

import Vue from 'vue';

export default {
  data() {
    return {
      loading: false,
      city: {
        id: 0,
        name: '',
        nameSlug: '',
        nameInfo: {},
        phone: '',
        published: '',
        geoCenter: '',
        priority: 0,
      },
    }
  },
  props: {},
  components: {},
  created() {
  },
  computed: {},
  methods: {
    show: function (item) {
      Vue.set(this, 'city', item);
      this.$refs.relationDialog.show();
      this.loading = true;
      this.axios.post('/admin/settings/cities/' + this.city.id + '/read', {}).then((payload) => {
        this.loading = false;
        Vue.set(this, 'city', payload.data);
      })
    },

    accept: function () {
      this.loading = true;
      this.axios.post('/admin/settings/cities/' + this.city.id + '/update', this.city).then(() => {
        this.loading = false;
        this.$refs.relationDialog.hide();
        this.$emit('closed');
      })
    },

    hide: function () {
      this.$refs.relationDialog.hide();
      this.$emit('closed');
    }
  }
}
</script>
<style scoped lang="scss">
input[type="checkbox"].large {
  height: 34px;
  width: 34px;
  top: 0;
  margin: 0;
  padding: 0;
  vertical-align: baseline;
}

.buttons {
  display: flex;

  .left {
    button[type=submit] {
      border-width: 1px !important;
    }
  }

  .right {
    flex: 1 0;
    align-content: flex-end;
    text-align: right;
  }
}

.dictionary-record {
  width: 500px;

  display: grid;
  grid-template-areas: "source key value";

  .source {
    grid-area: source;
  }

  .key {
    grid-area: key;
  }

  .value {
    grid-area: value;
  }
}
</style>
